// extracted by mini-css-extract-plugin
export default {"navigation-buttons":"booking-navigation_navigation-buttons__toJ3L"};